/* CYL Bundle Upsell — Temple Mount Soil
 *
 * PDP: a card offering the matching bundle; "Swap for the set" replaces the
 * single (removes any single-variant lines already in cart) and adds the
 * bundle variant matching the selected color, then opens the drawer.
 *
 * Cart drawer: window.CYL_BUNDLE_CONFIG (rendered by cart-drawer.liquid) maps
 * singleProductId -> { title, url, img, byVariant: { singleVariantId: {v,p} } }.
 * On every cart:updated we inject a "Make it a set" swap row under each mapped
 * single line; clicking it removes that line and adds the bundle variant.
 */
(function () {
  'use strict';
  // Loaded from BOTH buy-buttons.liquid (PDP) and cart-drawer.liquid (global),
  // so guard against double execution — otherwise the document-level click
  // listeners bind twice and one swap click fires the add twice.
  if (window.__cylBundleUpsellLoaded) { return; }
  window.__cylBundleUpsellLoaded = true;
  function ready(fn){ if(document.readyState!=='loading'){fn();} else {document.addEventListener('DOMContentLoaded',fn);} }
  function drawerEl(){ return document.querySelector('tms-cart-drawer'); }

  function addVariant(id){
    return fetch('/cart/add.js',{method:'POST',credentials:'same-origin',
      headers:{'Content-Type':'application/json','Accept':'application/json'},
      body:JSON.stringify({items:[{id:parseInt(id,10),quantity:1}]})});
  }
  function changeKey(key,qty){
    return fetch('/cart/change.js',{method:'POST',credentials:'same-origin',
      headers:{'Content-Type':'application/json','Accept':'application/json'},
      body:JSON.stringify({id:key,quantity:qty})});
  }
  function getCart(){
    return fetch('/cart.js',{credentials:'same-origin',headers:{'Accept':'application/json'}})
      .then(function(r){return r.ok?r.json():null;});
  }
  function openDrawer(){ var d=drawerEl(); if(d&&typeof d.open==='function'){d.open();} }
  function refreshDrawer(){ document.dispatchEvent(new CustomEvent('cart:refresh')); }

  /* ── PDP card ── */
  function initCards(root){
    (root||document).querySelectorAll('[data-cyl-bundle]').forEach(function(card){
      if(card.__cylInit){return;} card.__cylInit=true;
      var map; try{ map=JSON.parse(card.getAttribute('data-cyl-map')); }catch(e){ map=null; }
      var form=document.getElementById(card.getAttribute('data-cyl-form'));
      var priceEl=card.querySelector('[data-cyl-bundle-price]');

      function selVariant(){
        if(!form){return null;}
        var v=null; try{ v=new FormData(form).get('id'); }catch(e){}
        if(!v){ var i=form.querySelector('input[name="id"]:not([disabled])'); v=i&&i.value; }
        return v?String(v):null;
      }
      function syncPrice(){
        if(!map||!priceEl){return;}
        var sv=selVariant();
        if(sv&&map[sv]){ priceEl.textContent=map[sv].p; }
      }
      syncPrice();
      var scope=card.closest('.shopify-section')||document;
      scope.addEventListener('change',function(){ setTimeout(syncPrice,60); setTimeout(syncPrice,400); });

      var btn=card.querySelector('[data-cyl-bundle-swap]');
      if(btn){ btn.addEventListener('click',function(){
        if(!map){return;}
        var sv=selVariant();
        var target=(sv&&map[sv])?map[sv].v:null;
        if(!target){ var ks=Object.keys(map); if(ks.length){target=map[ks[0]].v;} }
        if(!target){return;}
        btn.disabled=true; openDrawer();
        getCart().then(function(cart){
          var jobs=[];
          if(cart&&cart.items){ cart.items.forEach(function(it){ if(map[String(it.variant_id)]){ jobs.push(changeKey(it.key,0)); } }); }
          return Promise.all(jobs);
        }).then(function(){ return addVariant(target); })
          .then(function(){ refreshDrawer(); })
          .catch(function(){})
          .finally(function(){ btn.disabled=false; });
      }); }
    });
  }

  /* ── Cart drawer swap rows ── */
  function injectRows(cart){
    var cfg=window.CYL_BUNDLE_CONFIG||{};
    var d=drawerEl(); if(!d||!cart||!cart.items){return;}
    var inCart={}; cart.items.forEach(function(it){ inCart[String(it.variant_id)]=true; });
    cart.items.forEach(function(it){
      var c=cfg[String(it.product_id)]; if(!c){return;}
      var bv=c.byVariant[String(it.variant_id)]; if(!bv){return;}
      if(inCart[String(bv.v)]){return;} // bundle already in cart
      var row=d.querySelector('.cd-item[data-cd-key="'+(window.CSS&&CSS.escape?CSS.escape(it.key):it.key)+'"]');
      if(!row){return;}
      if(row.nextElementSibling&&row.nextElementSibling.classList&&row.nextElementSibling.classList.contains('cd-bundle-swap')){return;}
      var el=document.createElement('div');
      el.className='cd-bundle-swap';
      el.innerHTML=
        '<img class="cd-bundle-swap__img" src="'+c.img+'" alt="">'+
        '<div class="cd-bundle-swap__copy">'+
          '<span class="cd-bundle-swap__title">Make it a set</span>'+
          '<span class="cd-bundle-swap__sub">'+c.title+' — '+bv.p+'</span>'+
        '</div>'+
        '<button type="button" class="cd-bundle-swap__btn" data-cyl-swap-key="'+it.key+'" data-cyl-swap-variant="'+bv.v+'">Swap</button>';
      row.insertAdjacentElement('afterend', el);
    });
  }

  document.addEventListener('cart:updated', function(e){ injectRows(e.detail&&e.detail.cart); });
  document.addEventListener('click', function(e){
    var b=e.target.closest&&e.target.closest('[data-cyl-swap-key]'); if(!b){return;}
    var key=b.getAttribute('data-cyl-swap-key');
    var vid=b.getAttribute('data-cyl-swap-variant');
    b.disabled=true;
    changeKey(key,0).then(function(){ return addVariant(vid); })
      .then(function(){ refreshDrawer(); })
      .catch(function(){})
      .finally(function(){ b.disabled=false; });
  });

  ready(function(){
    initCards(document);
    document.addEventListener('shopify:section:load', function(e){ initCards(e.target); });
    getCart().then(injectRows);
  });
})();
